import { Link, useParams } from "react-router-dom";

export default function LangLink({ to = "", children, ...props }) {
    const { lng } = useParams();

    if (!lng) {
        console.warn("LangLink used outside language route");
        return <></>;
    }

    const path =
        to.startsWith("/")
            ? `/${lng}${to}`
            : `/${lng}${to ? "/" + to : ""}`;


    return <Link {...props} to={path} >{children}</Link>;
}
